'use client';

import type { InterventionSession } from '@/lib/storage';
import { getContextLabel, getInteractionLabel } from '@/lib/content';

interface Props {
  sessions: InterventionSession[];
}

const ACTION_LABELS = {
  default: { label: 'Automatyczna', color: 'text-[hsl(0_65%_58%)]', bg: 'bg-[hsl(0_65%_58%/0.1)]' },
  neutral: { label: 'Zatrzymanie', color: 'text-[hsl(38_90%_62%)]', bg: 'bg-[hsl(38_90%_62%/0.1)]' },
  values: { label: 'Z wartości', color: 'text-[hsl(158_55%_52%)]', bg: 'bg-[hsl(158_55%_52%/0.1)]' },
};

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit' });
}

export default function RecentSessions({ sessions }: Props) {
  if (sessions.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-3xl mb-2">🌱</p>
        <p className="text-sm font-medium text-[hsl(var(--foreground))]">Brak sesji</p>
        <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
          Użyj przycisku STOP, aby rozpocząć pierwszą interwencję
        </p>
      </div>
    );
  }

  return (
    <div>
      <p className="text-xs font-medium text-[hsl(var(--muted-foreground))] uppercase tracking-wide mb-3">
        Ostatnie sesje
      </p>
      <div className="flex flex-col gap-2">
        {sessions.map((s) => {
          const action = ACTION_LABELS[s.actionChosen];
          return (
            <div
              key={`recent-${s.id}`}
              className="bg-[hsl(var(--card))] rounded-xl p-3.5 border border-[hsl(var(--border))] flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${action.color} ${action.bg}`}>
                    {action.label}
                  </span>
                  <span className="text-xs text-[hsl(var(--muted-foreground))] font-tabular">
                    {formatDate(s.date)}
                  </span>
                </div>
                <p className="text-xs text-[hsl(var(--muted-foreground))] truncate">
                  {getContextLabel(s.relationshipContext)} · {getInteractionLabel(s.interactionType)}
                </p>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="text-sm font-semibold text-[hsl(var(--foreground))] font-tabular">
                  {s.rating}/5
                </p>
                <p className="text-[10px] text-[hsl(var(--muted-foreground))]">ocena</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}